import { IPermissionRepository } from "domain/contracts/permission.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { Permission } from "domain/entities/permission";

class PermissionRepository implements IPermissionRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/permission/${id}`);
    return response.data;
  }

  async create(input: Permission): Promise<Message<Permission>> {
    const response = await httpClient.post(`/permission`, { data: input });
    return response.data;
  }

  async update(input: Permission): Promise<Message<boolean>> {
    const response = await httpClient.put(`/permission/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: BaseInputFilter): Promise<Message<Permission[]>> {
    const response = await httpClient.get(`/permission`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Permission>> {
    const response = await httpClient.get(`/permission/${id}`);
    return response.data;
  }
}

export default new PermissionRepository();
